module.exports = __webpack_public_path__ + "img/share_prize_bg.fd9f7cb8.png";